import React from 'react';
import Tooltip from 'rc-tooltip';
import dayjs from '@/lib/helpers/date';
import { Badge } from '@/lib/components/ui/badge';
import { User } from 'modules/App/interfaces';

type BadgeHolidayTooltipProps = React.HTMLAttributes<HTMLDivElement> & {
  user: User;
};

const BadgeHolidayTooltip: React.FC<BadgeHolidayTooltipProps> = ({ children, className, user, ...props }) => {
  if (!user?.onHolidays) {
    return null;
  }

  return (
    <Tooltip
      placement="bottom"
      trigger={['click', 'hover']}
      overlayClassName="opacity-100"
      overlay={
        <div>
          Jusqu’au <strong>{dayjs(user?.onHolidaysUntil).format('dddd DD MMMM')}</strong>
        </div>
      }
    >
      <Badge variant="holidays" size="sm" className="shadow-sm cursor-help" {...props} />
    </Tooltip>
  );
};

export default BadgeHolidayTooltip;
